const comments = [
  {
    name: '追剧小达人',
    text: '用了好几个平台，还是6080最好用。资源全、更新快，关键是免费还没有广告弹窗，追剧体验太棒了！',
    time: '2小时前',
    avatar: 'Z',
  },
  {
    name: '电影爱好者阿杰',
    text: '在这里找到了好多冷门好片，画质也很清晰。家里老人想看老电影也都能找到，真心推荐给身边朋友了。',
    time: '5小时前',
    avatar: 'J',
  },
  {
    name: '周末观影人',
    text: '每周五晚上固定来这刷一波新片，分类很清晰，找剧特别方便。希望平台越来越好，一直免费下去！',
    time: '1天前',
    avatar: 'Z',
  },
  {
    name: '动漫迷小雨',
    text: '国漫资源超全，更新速度和B站差不多。而且没有片头广告直接进入正片，看番不用等，太爽了。',
    time: '1天前',
    avatar: 'Y',
  },
  {
    name: '剧荒拯救者',
    text: '榜单和专题做得很好，每次不知道看什么就来看看推荐，从来没让我失望。评论区交到了好多同好！',
    time: '2天前',
    avatar: 'J',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            来自真实观众的使用反馈与评价
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 max-w-7xl mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 border border-background-200"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading font-bold text-sm flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <p className="font-heading font-semibold text-foreground-950 text-sm truncate">
                    {comment.name}
                  </p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-foreground-600 text-xs leading-relaxed">
                {comment.text}
              </p>
              <div className="flex items-center gap-0.5 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-400 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}